import defaultColor from "@/components/color";
export default {
    attribute:{
        label:'绘制区域:',
        size:'medium',
        showLable:true,
        cptTableData: [{ "name": "值", "value":"", "namekey": "value" }],
        bgColor: defaultColor[0],
        textColor: '#fff',
        radius: 6,
        zoom:14,
        centerx:116.387112,
        centery:39.920977,
        tareaValue:'1212',
        isOpen: 0,
    },
    cptDataForm: {//动态数据配置
        dataSource: 1, //默认数据源1:静态数据，2:api接口,3:SQL,4:数据集,5:websocket
        pollTime: 0,//默认轮询时间
        dataText: '{"value": "[[116.387112, 39.920977],[116.385243, 39.913063],[116.394226, 39.917988]]"}',//静态数据，必须为JSON格式
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
}